import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { AmenityStatus } from "~/utils";
import { useAppTranslation } from "~/hooks/useAppTranslation";

export const AvailabilityStatusTag = ({
  status,
}: {
  status: AmenityStatus;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("None");

  switch (status) {
    case AmenityStatus.Available:
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Available");
      break;
    case AmenityStatus.Reserved:
      color = "yellow";
      icon = <CloseCircleOutlined />;
      statusText = t("Reserved");
      break;
    case AmenityStatus.Unreservable:
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Unreservable");
      break;
    case AmenityStatus.Unavailable:
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Unavailable");
      break;
    case AmenityStatus.Open:
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Open");
      break;
    case AmenityStatus.Closed:
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Closed");
      break;
    case AmenityStatus.Unspecified:
      color = "yellow";
      icon = <CloseCircleOutlined />;
      statusText = t("Unspecified");
      break;
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
